<template>
  <div class="main-container">
    <v-img class="mb-8" v-if="logo" :src="`${apiUrl}/${logo}`" max-height="300px" aspect-ratio="1" contain></v-img>
    <!-- <div v-show="!logo" class="container header">
      <h1>{{title}}</h1>
    </div> -->
    <v-container class="mt-n8">
      <transition name="slide-fade" mode="out-in">
        <v-row
          :key="accionLevel"
          :justify="acciones.length > 1 ? 'space-between' : 'center'"
        >
          <v-col :cols="acciones.length > 1 ? 6 : 8" align="center"
            v-for="accion in acciones"
            :key="accion.accionId"
            >
              <v-btn
                color="primary"
                height="75px"
                width="80%"
                @click="goToPage(accion)">
                <p
                  class="mb-0"
                  :style="`font-size: ${calculateFontSize(accion.accionNombre)}px`"
                  >{{ capitalizeFirstLetter(accion.accionNombre) }}</p></v-btn>
          </v-col>
        </v-row>
      </transition>
    </v-container>
    <div v-if="showChildren" class="container">
      <v-btn
        class="btn-secondary"
        height="75px"
        @click="goBack">{{ getMessage('BTN_VOLVER') }}</v-btn>
    </div>
    <app-back-home v-if="showChildren" :compFrom="'TotemHome'"
    ></app-back-home>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import objectIsEmpty from '@/helpers/objectIsEmpty'
import BackHome from '@/components/AutoRecepcion/BackHome'
import getAPIUrl from '@/helpers/getAPIUrl'

let ipcRenderer
if (typeof process !== 'undefined' && process.type === 'renderer') {
  const { ipcRenderer: electronIpcRenderer } = require('electron')
  ipcRenderer = electronIpcRenderer
}

export default {
  components: {
    'app-back-home': BackHome
  },
  data () {
    return {
      apiUrl: '',
      accionesChildren: [],
      showChildren: false,
      accionLevel: 0,
      lastState: {},
      logo: '',
      totemId: null,
      salaId: null,
      esAccesoDirecto: false
    }
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage', 'getAccionesNavegacion']),
    ...mapGetters('InitConfig', ['getLogo', 'getMedia']),
    ...mapGetters(['getApiUrl']),
    ...mapState('InitConfig', ['terminalActual', 'salasNoAdministrativas']),
    ...mapState('GeneralAR', ['homeLastState']),
    title () {
      return this.getMessage('TTL_TITULO_HOME')
    },
    acciones () {
      return this.showChildren ? this.accionesChildren : this.getAccionesNavegacion
    }
  },
  watch: {
    getMedia (val) {
      this.setColor(val.primaryColor)
    },
    getApiUrl: function (val) {
      if (val) {
        this.initialConfig()
        this.fakeMounted()
      }
    }
  },
  async beforeCreate () {
    if (ipcRenderer) {
      ipcRenderer.send('readApiUrl')
      ipcRenderer.on('asynchronous-reply', (event, res) => {
        this.$store.commit('setApiUrl', res)
      })
    } else {
      const res = await getAPIUrl()
      this.$store.commit('setApiUrl', res)
    }
  },
  created () {
    if (this.getApiUrl) this.initialConfig()
  },
  async mounted () {
    if (this.getApiUrl) {
      this.fakeMounted()
    }
  },
  methods: {
    ...mapActions('Patient', ['setPatient', 'setPatients']),
    ...mapActions('GeneralAR', ['fetchAccionesAR', 'fetchMensajes']),
    ...mapActions('InitConfig', ['fetchMedia', 'fetchSalas', 'setSala', 'fetchParametrosGeneralesAmb']),
    ...mapMutations('InitConfig', ['setTerminal']),

    setSalaFromDirectAccess () {
      let salaActual
      this.fetchSalas().then(() => {
        // eslint-disable-next-line
        salaActual = this.salasNoAdministrativas.find(x => x.salaId == this.salaId)
        this.setSala(salaActual)
      })
    },
    goToPage (accion) {
      if (!accion) {
        /* eslint-disable no-console */
        console.error('Accion no configurada')
        return
      }
      if (accion.conTurno) {
        // temporal, no se estaba enviando el numRecId cuando tenia turno
        localStorage.setItem('numRecConTurno', accion.numRecId)
        localStorage.setItem('accionId', accion.accionId)
        this.$store.commit('GeneralAR/setHomeLastState', {})
        this.$router.push({ name: 'patientSearch' })
      } else {
        localStorage.removeItem('accionId')
        if (accion.numRecId) {
          this.$store.commit('GeneralAR/setHomeLastState', {})
          this.$router.push({ name: 'printNumber', params: { numRecId: accion.numRecId, accionId: accion.accionId } })
        } else {
          this.refreshButtons(accion.children)
        }
      }
    },
    // logica del mounted se pasa a un metodo para validar los casos de refresco de pantalla, en donde la url de la api se pierde
    // y hay que esperar que cargue nuevamente..
    fakeMounted () {
      this.apiUrl = this.getApiUrl
      // validar si hay parametros por url
      if (this.$route.params.totemId) {
        this.esAccesoDirecto = true
        this.totemId = this.$route.params.totemId
        this.salaId = this.$route.params.salaId
        this.setTerminal({ totemId: this.totemId })
        this.setSalaFromDirectAccess()
        this.fetchParametrosGeneralesAmb()
      }
      if (objectIsEmpty(this.getMedia)) {
        this.fetchMedia().then(() => {
          this.logo = this.getLogo()
          this.$forceUpdate()
        })
      }
      if (!this.logo) {
        this.fetchMedia().then(() => {
          this.logo = this.getLogo()
        })
      }
      this.fetchMensajes()
      if (this.acciones?.length === 0) {
        this.fetchAccionesAR(this.terminalActual)
      }
    },
    initialConfig () {
      this.setPatient({})
      this.setPatients([])
      if (!objectIsEmpty(this.homeLastState)) {
        this.accionesChildren = this.homeLastState.accionesChildren
        this.showChildren = this.homeLastState.showChildren
        this.accionLevel = this.homeLastState.accionLevel
      }
    },
    setColor (color) {
      if (/^#([0-9A-F]{3}){1,2}$/i.test(color)) {
        this.$vuetify.theme.themes.light.primary = color
      }
    },
    calculateFontSize (str) {
      if (str?.length < 17) return 28
      else if (str?.length < 20) return 22
      else if (str?.length < 23) return 20
      else if (str?.length < 26) return 18
      else if (str?.length >= 26) return 16
    },
    capitalizeFirstLetter (str) {
      str = str.toLowerCase()
      return str.charAt(0).toUpperCase() + str.slice(1)
    },
    goBack () {
      this.$store.commit('GeneralAR/setHomeLastState', {})
      this.accionLevel = 0
      this.showChildren = false
    },
    refreshButtons (acciones) {
      this.accionLevel += 1
      this.showChildren = true
      this.accionesChildren = acciones
      // se guarda el ultimo estado de navegacion de botones para restaurar si es necesario
      this.lastState = {
        accionLevel: this.accionLevel,
        showChildren: this.showChildren,
        accionesChildren: this.accionesChildren
      }
      this.$store.commit('GeneralAR/setHomeLastState', this.lastState)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
.v-btn {
  /*text*/
  text-transform:unset;
  font-family: "Roboto", sans-serif;
  font-size: 28px !important;
  text-align: center;
  letter-spacing: 0;
  color: #ffffff;
  /*btn*/
  background-color: var(--v-primary-base);
  border: 1px solid var(--v-primary-base);
  border-radius: 4px;
  opacity: 1;
  width: 65%;
  height: 75px;
  margin: 20px;
}
.btn-secondary {
  /*text*/
  font-family: "Roboto", sans-serif;
  font-size: 28px;
  text-align: center;
  letter-spacing: 0;
  color: var(--v-primary-base);
  /*btn*/
  background-color: #ffffff !important;
  border: 1px solid var(--v-primary-base);
  border-radius: 4px;
  opacity: 1;
  width: 25%;
  height: 75px;
  margin: 40px;
  text-transform: capitalize;
  font-weight: 400;
}

.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateZ(100px);
  opacity: 0;
}
</style>
